import classNames from 'classnames';
import { Check, Info } from 'lucide-react';
import ReactMarkdown from 'react-markdown';

import type * as Pricing from '@/pricing/types';
import { Tooltip } from '@/src/ui/Tooltip/Tooltip';

import styles from './FeaturesList.module.scss';

interface Props {
    className?: string;
    overview: Pricing.OverviewFeature[];
}

export function FeaturesList({ className, overview }: Props) {
    return (
        <ul className={classNames(styles.list, className)}>
            {overview.map((feature, index) => (
                <li key={`feature_${index}`} className={styles.item}>
                    <div className={styles.checkbox}>
                        <Check className={styles.icon} />
                    </div>
                    <div className={styles.name}>
                        <ReactMarkdown>{feature.name}</ReactMarkdown>
                    </div>
                    {feature.details && (
                        <Tooltip
                            placement="right"
                            tooltip={
                                <div className={styles.tooltip}>
                                    <p>{feature.details}</p>
                                </div>
                            }
                        >
                            {({ ariaAttributes, onHide, onShow, setReferenceElement }) => (
                                // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                                <span
                                    {...ariaAttributes}
                                    className={styles.tooltipTrigger}
                                    onMouseEnter={onShow}
                                    onMouseLeave={onHide}
                                    ref={setReferenceElement}
                                >
                                    <Info className={styles.icon} />
                                </span>
                            )}
                        </Tooltip>
                    )}
                </li>
            ))}
        </ul>
    );
}
